import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function CareCreditSection() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-1179">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1180">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1181">
          {/* Left Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1182">
            <span className="text-[#FF1493] uppercase text-[13px] font-bold tracking-[2px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1183">
              FINANCING PARTNER
            </span>

            <h2 className="text-[28px] sm:text-4xl lg:text-[44px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1184">
              HOW CARECREDIT WORKS
            </h2>

            <p className="text-[#FF1493] text-xl font-serif italic mb-10" data-id="element-1185">
              A Healthcare Credit Card Designed For Your Health And Wellness
              Needs.
            </p>

            <div className="space-y-8 mb-10" data-id="element-1186">
              <div data-id="element-1187">
                <h3 className="text-white font-bold text-lg mb-2 font-[Poppins,_sans-serif]" data-id="element-1188">
                  See if you Prequalify Without Impacting Your Credit Score
                </h3>
                <p className="text-[#B0B0B0] text-[15px] font-body leading-[1.7]" data-id="element-1189">
                  If qualified, you can apply immediately – no activation fee
                  and no need to re-apply. (Application will result in a hard
                  inquiry.)
                </p>
              </div>

              <div data-id="element-1190">
                <h3 className="text-white font-bold text-lg mb-2 font-[Poppins,_sans-serif]" data-id="element-1191">
                  What Makes CareCredit Different
                </h3>
                <p className="text-[#B0B0B0] text-[15px] font-body leading-[1.7]" data-id="element-1192">
                  Use it to pay for out-of-pocket expenses not covered by
                  medical insurance, and special financing options are available
                  that you may not be able to get with other cards. Pay for
                  health, and wellness care at over 250,000 enrolled providers
                  across the nation. Once you've applied, you can use it again
                  and again at any location that accepts CareCredit.
                </p>
              </div>

              <div data-id="element-1193">
                <h3 className="text-white font-bold text-lg mb-2 font-[Poppins,_sans-serif]" data-id="element-1194">
                  Flexible Terms
                </h3>
                <p className="text-[#B0B0B0] text-[15px] font-body leading-[1.7]" data-id="element-1195">
                  With shorter term financing options of 6, 12, 18 or 24 months
                  no interest is charged on purchases of $200 or more when you
                  make the minimum monthly payments and pay the full amount due
                  by the end of the promotional period. If you do not, interest
                  is charged from the original purchase date.
                </p>
              </div>

              <div data-id="element-1196">
                <h3 className="text-white font-bold text-lg mb-2 font-[Poppins,_sans-serif]" data-id="element-1197">
                  Why Wait to Look Great?
                </h3>
                <p className="text-[#B0B0B0] text-[15px] font-body leading-[1.7]" data-id="element-1198">
                  If you're looking to enhance your appearance and confidence
                  through cosmetic surgery or other beauty procedures, the
                  CareCredit credit card can help make it possible by providing
                  an easy and convenient way to pay at locations in the
                  CareCredit network.
                </p>
              </div>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-1199">
              SIGN UP WITH CARECREDIT
            </Button>
          </AnimateOnScroll>

          {/* Right Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-1200">
            <div className="relative mx-auto max-w-[400px] lg:max-w-none bg-[#111111] rounded-2xl p-12 aspect-square flex items-center justify-center border border-white/5 shadow-[0_0_40px_rgba(255,20,147,0.1)]" data-id="element-1201">
              <div className="absolute inset-0 bg-gradient-to-br from-[#FF1493]/10 to-transparent rounded-2xl" data-id="element-1202"></div>
              <h3 className="text-4xl font-bold text-white relative z-10 font-[Poppins,_sans-serif] tracking-wider text-center" data-id="element-1203">
                CareCredit
              </h3>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}